import PosthogService from '~/services/posthog/PosthogService';

export interface IBulkConfirmCandidateSelectedPayload {
  candidateId?: string;
  shiftId: string;
}

/**
 * Fires when a shift is selected on the bulk "Confirm Shifts" page.
 * Event: dental_portal:bulk_confirm:candidate_selected
 */
export function fireBulkConfirmCandidateSelected(
  payload: IBulkConfirmCandidateSelectedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:bulk_confirm:candidate_selected', {
    candidate_id: payload.candidateId,
    shift_id: payload.shiftId,
  });
}
